import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mywork-container content-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg" }, "我的作品和模版", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " 还没有任何作品 ", -1)
const _hoisted_4 = { class: "ant-pagination" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_works_list = _resolveComponent("works-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      type: "flex",
      justify: "space-between",
      align: "middle",
      class: "poster-title"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_input_search, {
          value: _ctx.searchText,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          placeholder: "搜索作品标题",
          style: {"width":"320px"},
          onSearch: _ctx.onSearch
        }, null, 8, ["value", "onSearch"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_tabs, { onChange: _ctx.changeCategory }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "0",
          tab: "我的作品"
        }),
        _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "我的模版"
        })
      ]),
      _: 1
    }, 8, ["onChange"]),
    (_ctx.works.length === 0 && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_a_empty, { key: 0 }, {
          description: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 创建你的第一个设计 🎉 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_works_list, {
      list: _ctx.works,
      loading: _ctx.isLoading,
      onOnDelete: _ctx.onDelete,
      onOnCopy: _ctx.onCopy
    }, null, 8, ["list", "loading", "onOnDelete", "onOnCopy"]),
    _createVNode(_component_a_row, {
      type: "flex",
      justify: "space-between",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", {
            class: _normalizeClass(["ant-pagination-prev", { 'ant-pagination-disabled pointer-events-none': _ctx.isFirstPage }])
          }, [
            _createElementVNode("a", {
              class: "ant-pagination-item-link",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadPrevPage && _ctx.loadPrevPage(...args)), ["prevent"]))
            }, " 上一页 ")
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPage, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item,
              class: _normalizeClass(["ant-pagination-item", { 'ant-pagination-item-active': _ctx.pageIndex + 1 === item }])
            }, [
              _createElementVNode("a", {
                onClick: _withModifiers(($event: any) => (_ctx.goToPage(item - 1)), ["prevent"])
              }, _toDisplayString(item), 9, _hoisted_5)
            ], 2))
          }), 128)),
          _createElementVNode("li", {
            class: _normalizeClass(["ant-pagination-next", { 'ant-pagination-disabled pointer-events-none': _ctx.isLastPage }])
          }, [
            _createElementVNode("a", {
              class: "ant-pagination-item-link",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadMorePage && _ctx.loadMorePage(...args)), ["prevent"]))
            }, " 下一页 ")
          ], 2)
        ]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.pageIndex + 1), 1)
      ]),
      _: 1
    })
  ]))
}